import { render, staticRenderFns } from "./employer-list.vue?vue&type=template&id=5b05a9ed"
import script from "./employer-list.vue?vue&type=script&lang=ts"
export * from "./employer-list.vue?vue&type=script&lang=ts"
import style0 from "./employer-list.vue?vue&type=style&index=0&id=5b05a9ed&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports